<ng-content />
@switch (direction()) {
@case('') { <i data-testid="SUBSYS2_LIST_HEADER_ORDER_NONE" class="material-icons">swap_vert</i> }
@case('asc') { <i data-testid="SUBSYS2_LIST_HEADER_ORDER_ASC" class="material-icons">keyboard_arrow_down</i> }
@case('desc') { <i data-testid="SUBSYS2_LIST_HEADER_ORDER_DESC" class="material-icons">keyboard_arrow_up</i> }
@default {}
}